<template>
  <div class="app-container">
    <div style="margin-top:15px" align="center">
      <el-form ref="form" :model="form" :rules="rules" size="big" label-width="120px" style="width:750px">

        <el-form-item label="调查地点" prop="address">
          <el-input v-model="form.address" placeholder="请输入调查地点" size="big"></el-input>
        </el-form-item>
        <el-form-item label="经纬度">
          <el-input v-model="form.longitude" placeholder="请输入经度" size="big"></el-input>
          <el-input v-model="form.latitude" placeholder="请输入纬度" size="big"></el-input>
        </el-form-item>
        <el-form-item label="作物种类">
          <el-select v-model="form.cropSpecies" placeholder="作物种类" style="width:100%" clearable>
            <el-option
              v-for="item in form.cropSpeciesList"
              :key="item.SID"
              :label="item.C_NAME"
              :value="item.SID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="雄虫头数" prop="maleNumber">
          <el-input v-model="form.maleNumber" placeholder="请输入雄虫头数" size="big">
            <template slot="append">头/套·天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="诱捕器类型">
          <el-select v-model="form.trapType" placeholder="作物种类" style="width:100%" clearable>
            <el-option
              v-for="item in form.trapTypeList"
              :key="item.SID"
              :label="item.C_NAME"
              :value="item.SID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性(食)诱剂型号" prop="inducerModel">
          <el-input v-model="form.inducerModel" placeholder="请输入性(食)诱剂型号" size="big"></el-input>
        </el-form-item>
        <el-form-item label="厂商名" prop="manufacturerName">
          <el-input v-model="form.manufacturerName" placeholder="请输入厂商名" size="big"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="form.remarks" placeholder="请输入备注" size="big"></el-input>
        </el-form-item>
        <el-form-item label="上传图片">
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">请上传调查田块全局照片、监测设备照片和监测结果</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="提交报告">
          <el-button type="primary" icon="el-icon-upload" :loading="loading2" @click="upload('form')">提交报告</el-button>
        </el-form-item>
        <!--<el-select v-model="mineStatus" placeholder="请选择" multiple filterable @change="selectChange"-->
        <!--:multiple-limit="deptLimit">-->
        <!--<el-option  :value="mineStatusValue" style="height: auto">-->
        <!--<el-tree :data="data" show-checkbox node-key="id" ref="tree"-->
        <!--highlight-current :props="defaultProps"-->
        <!--@check-change="handleCheckChange"-->
        <!--:check-strictly="true"></el-tree>-->
        <!--</el-option>-->
        <!--</el-select>-->
      </el-form>
    </div>
    <!--<div style="margin-top:5px"><span>Step1: 输入地理位置及预测范围 （注意：玉米抽样指标：头/百株 | 小麦抽样指标：头/平米）</span></div>-->
    <!--<div style="margin-top:15px">-->
      <!--<el-form ref="form" :inline="true" :model="form" :rules="rules" size="big" label-width="120px">-->
        <!--<el-form-item label="地理位置" prop="location">-->
          <!--<el-input v-model="form.location" placeholder="请输入位置" size="big"></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item>-->
            <!--<el-button :loading="loading" type="success" icon="el-icon-position" @click="getlocation">自动定位</el-button>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="预测范围" prop="radio">-->
            <!--<el-radio border v-model="radio" label="30">30天预测</el-radio>-->
            <!--<el-radio border v-model="radio" label="60">60天预测</el-radio>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
    <!--</div>-->
    <!--<div><span>Step2: 选择预测模型 （注意：动态数量预测只支持30天预测）</span></div>-->
    <!--<div style="margin-top:15px">-->
      <!--<el-radio-group v-model="form.modeltype" size="medium" @change="changeModel">-->
        <!--<el-radio border label="发生期预测"></el-radio>-->
        <!--<el-radio border label="动态数量预测"></el-radio>-->
      <!--</el-radio-group>-->
    <!--</div>-->
    <!--<div v-show="!selectedModelType" style="margin-top:15px">-->
      <!--<span>田间调查结果: </span>-->
        <!--<el-select v-model="form.value" placeholder="请选择">-->
          <!--<el-option-->
            <!--v-for="item in options"-->
            <!--:key="item.value"-->
            <!--:label="item.label"-->
            <!--:value="item.value">-->
          <!--</el-option>-->
        <!--</el-select>-->
    <!--</div>-->
    <!--<div v-show="selectedModelType" style="margin-top:15px">-->
      <!--<el-table :data="initTableData" stripe style="width: 50%; text-align: center; margin: 0 auto;" class="tb-edit" border-->
                <!--:header-cell-style="{background:'#3d80f2',color:'#fff',fontSize:'14px',height:'40px'}">-->
        <!--<el-table-column prop="inputvalue0" label="卵块">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue0" placeholder="请输入发生数量"-->
                      <!--:rules="[-->
                            <!--{ required: true, message: '不能为空'},-->
                            <!--{ type: 'number', message: '必须为数字'}-->
                          <!--]"-->
            <!--&gt;</el-input>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue1" label="1龄幼虫">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue1" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue2" label="2龄幼虫">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue2" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue3" label="3龄幼虫">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue3" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue4" label="4龄幼虫">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue4" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->

          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue5" label="5龄幼虫">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue5" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->

          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue6" label="6龄幼虫">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue6" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->

          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue7" label="蛹">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue7" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->

          <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="inputvalue8" label="成虫">-->
          <!--<template slot-scope="scope">-->
            <!--<el-input v-model="scope.row.inputvalue8" placeholder="请输入发生数量"-->
            <!--&gt;</el-input>-->

          <!--</template>-->
        <!--</el-table-column>-->
      <!--</el-table>-->
    <!--</div>-->
    <!--<div style="margin-top:15px">-->
      <!--<el-button type="primary" icon="el-icon-search" :loading="loading2" @click="search('form')">查询</el-button>-->
    <!--</div>-->
    <!--&lt;!&ndash;<div slot="footer" class="dialog-footer">&ndash;&gt;-->
      <!--&lt;!&ndash;<div id="myChart" :style="{ height: '600px'}"></div>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--<div slot="footer" class="dialog-footer" v-loading="loading2">-->
      <!--&lt;!&ndash;<div id="myChart" :style="{width: '1200px', height: '600px'}"></div>&ndash;&gt;-->
      <!--<div id="myChartSex" :style="{ height: '600px'}"></div>-->
      <!--<div class="content" v-if="tableData.length>0 && selectedModelType==false">-->
        <!--<el-table :data="tableData"-->
                  <!--tooltip-effect="dark"-->
                  <!--style="width: 80%; text-align: center; margin: 0 auto;border: 1px solid #68a7f9; "-->
                  <!--:row-class-name="tableRowClassName"-->
                  <!--:header-cell-style="{background:'#3d80f2',color:'#fff',fontSize:'16px',height:'55px'}">-->
          <!--<el-table-column prop="phase" label="阶段"></el-table-column>-->
          <!--<el-table-column prop="method" label="防治方法"></el-table-column>-->
          <!--<el-table-column prop="startDate" label="开始日期"></el-table-column>-->
          <!--<el-table-column prop="endDate" label="结束日期"></el-table-column>-->
        <!--</el-table>-->
      <!--</div>-->
      <!--<div class="content" v-if="selectedModelType">-->
        <!--<div style="margin-top:5px"><el-tag type="danger">田间调查幼虫总量：{{sumData}}头/百株</el-tag></div>-->
        <!--<div style="margin-top:5px">-->
          <!--<el-table :data="newtableData"-->
                    <!--tooltip-effect="dark"-->
                    <!--style="width: 80%; text-align: center; margin: 0 auto;border: 1px solid #68a7f9; "-->
                    <!--:row-class-name="tableRowClassName"-->
                    <!--:header-cell-style="{background:'#3d80f2',color:'#fff',fontSize:'16px',height:'55px'}">-->
            <!--<el-table-column prop="status" label="虫情"></el-table-column>-->
            <!--<el-table-column prop="method" label="防治方法"></el-table-column>-->
          <!--</el-table>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
    import {getWeatherData,getData} from '@/api/Weather'
    import {getUserLocation} from '@/api/Weather'

    export default {
        name: 'SexTrap',
        data() {
            return {
              fileList: [],
                msg: '草地贪夜蛾羽化预测',
                sumData:'',
                tableData: [],
                loading: false,
                loading2: false,
                userlocation: '',
                selectedModelType: false,
                inputvalue0: '',
                inputvalue1: '',
                inputvalue2: '',
                radio: '30',
                form: {location: '', value: '', modeltype: '发生期预测', type: '',
                  ADDFILE: [],longitude:'',latitude:'',cropSpecies:'',
                  cropSpeciesList:[{SID:'1',C_NAME:'玉米'},{SID:'2',C_NAME:'小麦'},{SID:'3',C_NAME:'水稻'},{SID:'4',C_NAME:'甘蔗'},{SID:'5',C_NAME:'高粱'},{SID:'6',C_NAME:'大豆'},{SID:'7',C_NAME:'马铃薯'},{SID:'8',C_NAME:'棉花'},{SID:'9',C_NAME:'花生'},{SID:'10',C_NAME:'小米（谷子）'},{SID:'11',C_NAME:'甘蓝'},{SID:'12',C_NAME:'辣椒'}],
                  maleNumber:'',trapType:'',
                  trapTypeList:[{SID:'1',C_NAME:'水盆型诱捕器'},{SID:'2',C_NAME:'桶型诱捕器'},{SID:'3',C_NAME:'瓶式诱捕器'},{SID:'4',C_NAME:'二十四孔诱捕器'},{SID:'5',C_NAME:'船型诱捕器'},{SID:'6',C_NAME:'三角形诱捕器'},{SID:'7',C_NAME:'其他'}],
                  inducerModel:'',manufacturerName:'',remarks:'',
                },
                initTableData: [{inputvalue0:'0',inputvalue1:'0',inputvalue2:'0',inputvalue3:'0',inputvalue4:'0',inputvalue5:'0',
                    inputvalue6:'0',inputvalue7:'0',inputvalue8:'0',}],

      rules: {
        location: [
          { required: true, message: '请输入地理位置', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '田间调查结果不能为空', trigger: 'blur' }
        ],
        inputvalue0:[{pattern: /^-?\d+\.?\d*$/, message: '请输入数字', trigger: 'blur' }],
      },
//              initrules:{
//                inputvalue0:[{pattern: /^-?\d+\.?\d*$/, message: '请输入数字', trigger: 'blur' }],
//                inputvalue1:[{pattern: /^-?\d+\.?\d*$/, message: '请输入数字', trigger: 'blur' }],
//
//              },
//      activeName: 'first',
      options: [{
        value: '0',
        label: '卵块'
      }, {
        value: '1',
        label: '1龄幼虫'
      }, {
        value: '2',
        label: '2龄幼虫'
      }, {
        value: '3',
        label: '3龄幼虫'
      }, {
        value: '4',
        label: '4龄幼虫'
      }, {
        value: '5',
        label: '5龄幼虫'
      }, {
        value: '6',
        label: '6龄幼虫'
      }, {
        value: '7',
        label: '蛹'
      }, {
        value: '8',
        label: '成虫'
      }],
      value: '',
      newtableData: [{
        status: '百株虫量 < 10头',
        method: '保持观察'
      }, {
        status: '10头 < 百株虫量 < 20头',
        method: '采用生物农药或生物防治方法'
      }, {
        status: '百株虫量 > 20头',
        method: '化学农药'
      }]
    }
  },
  mounted(){
//    this.drawLine();
//    this.drawdataLine();
  },
  methods: {

//  search(ip) {
//      getLocation(ip).then(result => {
//        this.drawVolumeLine(result.data);
////        console.log(result)
//    }).catch(function(error) {
//        console.log(error);
//      });
//    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    changeModel(value){
      if(value=="动态数量预测"){
        this.selectedModelType = true;
      }else
      {
        this.selectedModelType = false;
      }
//      console.log(value);
    },
    getlocation(){
      let that = this;
      that.loading = true;
      var geolocation = new BMap.Geolocation();
      // 开启SDK辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
//          var mk = new BMap.Marker(r.point);
//          alert('您的位置：' + r.point.lng + ',' + r.point.lat);
          getUserLocation(r.point.lng, r.point.lat).then(
                  result => {
                    that.form.location = result.data['locationName'];
                    console.log(result.data['locationName']);
              }
          ).catch(function(error) {
            console.log(error);
          });
//          this.form.location = ;
//          $("#mylocation").text("自动定位");
                        that.loading = false;
                    } else {
                        alert('failed状态' + this.getStatus());
                        that.loading = false;
                    }
                });
            },
            upload(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let that = this;
                        that.loading2 = true;
                      alert("提交成功");
                      that.loading2 = false;
//                        if (that.selectedModelType==false)
//                        {
//                            that.tableData=[];
//                            getWeatherData(that.form.location, that.form.value, that.radio).then(result => {
//                                this.drawLine(result.data);
//                                console.log(result.data)
//                                that.loading2 = false;
//                            }).catch(function (error) {
//                                console.log(error);
//                                that.loading2 = false;
//                            });
//                        }
//                        else
//                        {
//                            that.tableData=[];
//                            let fawData=[];
//                            fawData.push(that.initTableData[0].inputvalue0);
//                            fawData.push(that.initTableData[0].inputvalue1);
//                            fawData.push(that.initTableData[0].inputvalue2);
//                            fawData.push(that.initTableData[0].inputvalue3);
//                            fawData.push(that.initTableData[0].inputvalue4);
//                            fawData.push(that.initTableData[0].inputvalue5);
//                            fawData.push(that.initTableData[0].inputvalue6);
//                            fawData.push(that.initTableData[0].inputvalue7);
//                            fawData.push(that.initTableData[0].inputvalue8);
//                            console.log(fawData.toString().replace(/,/g,"-"));
//                            that.sumData = parseInt(that.initTableData[0].inputvalue1)+parseInt(that.initTableData[0].inputvalue2)+parseInt(that.initTableData[0].inputvalue3)+
//                              parseInt(that.initTableData[0].inputvalue4)+parseInt(that.initTableData[0].inputvalue5)+parseInt(that.initTableData[0].inputvalue6);
//                            getData(that.form.location, fawData.toString().replace(/,/g,"-"), that.radio).then(result => {
//                                console.log(result.data)
//                                this.drawdataLine(result.data);
//                                that.loading2 = false;
//                            }).catch(function (error) {
//                                console.log(error);
//                                that.loading2 = false;
//                            });
//                        }

                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            search(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let that = this;
          that.loading2 = true;
          if (that.selectedModelType==false)
          {
            that.tableData=[];
            getWeatherData(that.form.location, that.form.value, that.radio).then(result => {
            this.drawLine(result.data);
            console.log(result.data)
            that.loading2 = false;
          }).catch(function (error) {
            console.log(error);
            that.loading2 = false;
          });
          }
          else
          {
            that.tableData=[];
            let fawData=[];
            fawData.push(that.initTableData[0].inputvalue0);
            fawData.push(that.initTableData[0].inputvalue1);
            fawData.push(that.initTableData[0].inputvalue2);
            fawData.push(that.initTableData[0].inputvalue3);
            fawData.push(that.initTableData[0].inputvalue4);
            fawData.push(that.initTableData[0].inputvalue5);
            fawData.push(that.initTableData[0].inputvalue6);
            fawData.push(that.initTableData[0].inputvalue7);
            fawData.push(that.initTableData[0].inputvalue8);
            console.log(fawData.toString().replace(/,/g,"-"));
            that.sumData = parseInt(that.initTableData[0].inputvalue1)+parseInt(that.initTableData[0].inputvalue2)+parseInt(that.initTableData[0].inputvalue3)+
              parseInt(that.initTableData[0].inputvalue4)+parseInt(that.initTableData[0].inputvalue5)+parseInt(that.initTableData[0].inputvalue6);
            getData(that.form.location, fawData.toString().replace(/,/g,"-"), that.radio).then(result => {
              console.log(result.data)
            this.drawdataLine(result.data);
            that.loading2 = false;
          }).catch(function (error) {
            console.log(error);
            that.loading2 = false;
          });
          }

                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            //   表格各行变色
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 == 0) {
                    return "warning-row";
                } else {
                    return "success-row";
                }
            },
            drawLine(result) {
                let that = this;
                let markArea = [];
                let markAreaColor = [{name: '卵', color: '#FFFACD'},
                    {name: '1龄幼虫', color: '#FFA54F'},
                    {name: '2龄幼虫', color: '#2a81cd'},
                    {name: '3龄幼虫', color: '#23b2ff'},
                    {name: '4龄幼虫', color: '#bf4385'},
                    {name: '5龄幼虫', color: '#CD2626'},
                    {name: '6龄幼虫', color: '#c773cd'},
                    {name: '蛹', color: '#1fc6cd'},
                    {name: '成虫', color: '#39cd42'}];
                let datatmp = [];

      result.duration.forEach(item => {
        let data = [];
        datatmp.push({
          phase: item[0],
          method: item[1],
          startDate: item[2],
          endDate: item[3]
        });
        let color = '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).substr(-6);
        markAreaColor.map(function (coloritem) {
          if (item[0] == coloritem.name) {
            console.log('coloritem.color:' + coloritem.color)
            color = coloritem.color;
          }
        })
        data.push({
          name: item[0],
          xAxis: item[2],
          itemStyle: {
            color: color,
            fontSize: '8px'
          }
        });
        data.push(
          {
            xAxis: item[3]
          }
        )
        markArea.push(data);
      });

      that.tableData = datatmp;
      console.log(that.tableData);
      console.log(markArea);

      let myChart = this.$echarts.init(document.getElementById('myChartSex'))
      myChart.clear();
      myChart.setOption({
        title: {
          text: '草地贪夜蛾积温预测',
          subtext: '日平均积温法'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['最高气温', '最低气温']
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: result['temp'].map(function (item) {
            console.log(item['Date']);
            return item['Date'];
          })
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} °C'
          }
        },
        series: [
          {
            name: '最高气温',
            type: 'line',
            areaStyle: {},
            data: result['temp'].map(function (item) {
              console.log(item['maxTem']);
              return item['maxTem'];
            }),
            markPoint: {
              data: [
                {type: 'max', label:'最大值',name: '最大值'},
                {type: 'min', name: '最小值'},
//                {name: '坐标', coord: ['2020-3-27', 20],label:'预测羽化日'}
                                ]
                            },
                            markLine: {
                                data: [
                                    {type: 'average', name: '平均值'},
                                    {
                                        name: '发育起点温度',
                                        yAxis: 12,
                                        symbol: 'rect',
                                        lineStyle: {color: 'black', width: '3'},
                                        label: '发育起点温度'
                                    },
                                    {
                                        name: '发育停止温度',
                                        yAxis: 38,
                                        symbol: 'rect',
                                        lineStyle: {color: 'red', width: '3'},
                                        label: '发育停止温度'
                                    },
                                ]
                            }
                        },
                        {
                            name: '最低气温',
                            type: 'line',
                            areaStyle: {},
                            data: result['temp'].map(function (item) {
                                console.log(item['minTem']);
                                return item['minTem'];
                            }),
                            markPoint: {
                                data: [
//                {name: '周最低', value: -2, xAxis: 1, yAxis: -1.5}
              ]
            },
            markLine: {
              data: [
                {type: 'average', name: '平均值'},
//                [{
//                  symbol: 'none',
//                  x: '90%',
//                  yAxis: 'max'
//                }, {
//                  symbol: 'circle',
//                  label: {
//                    position: 'start',
//                    formatter: '最大值'
//                  },
//                  type: 'max',
//                  name: '最高点'
//                }]
                                ]
                            },
                            markArea: {
                                data: markArea
                            },
                        }
                    ]
                });
            },
            drawdataLine(result) {
                let Date=result.DateList;
                Date.splice(0, 0, "product");
                let data=result.DataList;

                let seriesData=[];
                let sourcedata=[];
                sourcedata.push(Date);

                data.forEach(item => {
                    let items=item.split(',');
                    sourcedata.push(items)
                    seriesData.push({type: 'line', smooth: true, seriesLayoutBy: 'row'})
                });
                seriesData.push( {
                    type: 'pie',
                    id: 'pie',
                    radius: '30%',
                    center: ['50%', '35%'],
                    label: {
                        formatter: '{b}: {@'+Date[1]+'} ({d}%)'
                    },
                    encode: {
                        itemName: 'product',
                        value: Date[1],
                        tooltip: Date[1]
                    }
                })
                console.log(sourcedata);
                console.log(seriesData);

                let myChart = this.$echarts.init(document.getElementById('myChart'))
                myChart.clear();
                setTimeout(function () {

                    var option = {
                        legend: {
                        },
                        tooltip: {
                            trigger: 'axis',
                            showContent: true
                        },
                        dataset: {
                            source: sourcedata
                        },
                        xAxis: {type: 'category'},
                        yAxis: {gridIndex: 0},
                        grid: {top: '55%'},
                        series: seriesData
                    };

        myChart.on('updateAxisPointer', function (event) {
          var xAxisInfo = event.axesInfo[0];
          if (xAxisInfo) {
            var dimension = xAxisInfo.value + 1;
            myChart.setOption({
              series: {
                id: 'pie',
                label: {
                  formatter: '{b}: {@[' + dimension + ']} ({d}%)'
                },
                encode: {
                  value: dimension,
                  tooltip: dimension
                }
              }
            });
          }
        });

        myChart.setOption(option);

      });
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-table .warning-row {
    background: #f4f8fe;
  }

  .el-table .success-row {
    background: #fff;
  }
</style>
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
